<template>
    <div class="lgsorder-details ">
        <ul class="mb66">
            <li>
                <span>名称</span>
                <span>{{ jxborderDetails.productName }}</span>
            </li>
            <li>
                <span>出借本金</span>
                <span>{{ format(Number(jxborderDetails.amount).toFixed(2)) }}元</span>
            </li>
            <li>
                <span>已回款本金</span>
                <span>{{ format(Number(jxborderDetails.repayAmount).toFixed(2)) }}元</span>
            </li>
            <li>
                <span>借款年利率</span>
                <span>{{ jxborderDetails.annualRate && (parseFloat(jxborderDetails.annualRate) * 100).toFixed(2) }}%</span>
            </li>
            <li>
                <span>期待回报</span>
                <span>{{ format(Number(jxborderDetails.revenue).toFixed(2)) }}元</span>
            </li>
            <li>
                <span>已完成回报</span>
                <span>{{ format(Number(jxborderDetails.totalRevenue).toFixed(2)) }}元</span>
            </li>
            <li>
                <span>还款方式</span>
                <span>{{ jxborderDetails.repayWay }}</span>
            </li>
            <li>
                <span>借款期限</span>
                <span>{{ jxborderDetails.dealPeriod }}</span>
            </li>
            <li>
                <span>交易状态</span>
                <span>{{ jxborderDetails.statusDescription }}</span>
            </li>
            <li>
                <span>下单时间</span>
                <span>{{ jxborderDetails.createTime }}</span>
            </li>
            <li>
                <span>支付时间</span>
                <span>{{ jxborderDetails.payTime }}</span>
            </li>
            <li>
                <span>交易单号</span>
                <span>{{ jxborderDetails.dealNo }}</span>
            </li>
            <!-- 已付款的状态 -->
            <!-- 出借成功的状态 -->
            <!--  <li>
                <span>支付方式</span>
                <span>存管余额支付</span>
            </li> -->
            <li data-url="jxbdetailsRefund" @click="goRefund($event)" v-if="jxborderDetails.status > 2">
                <span>回款详情</span>
                <span class="arrow"></span>
            </li>
            <li data-url="informationDisclosure" @click="goInfo($event)" v-if="jxborderDetails.status > 2">
                <span>借款期间信息披露</span>
                <span class="arrow"></span>
            </li>
            <!-- 出借成功的状态 -->
        </ul>
        <div class="view-protocol">
            <template v-if="jxborderDetails.status == 0">
                <div class="smallBtn" @click="cancelOrder">取消订单</div>
                <div class="smallBtn gradualGold" @click="payment">立即支付</div>
            </template>
            <template v-else>
                <div class="smallBtn" @click="downFile">查看协议</div>
            </template>
        </div>
    </div>
</template>
<script>
import { bridgeRedirect, downloadFile, redirectApp, callHandler } from "../../../utils/bridge";
import { formatNumber } from "@/utils/index";
import sensors from "sa-sdk-javascript";

export default {
    data() {
        return {
            jxborderDetails: {},
            token: "",
            shows: true
        };
    },
    created() {
        let params = this.$queryUrl(location.href);
        const { token, dealNo } = params;
        this.token = decodeURIComponent(token || "");
        this.dealNo = dealNo;
        //decodeURIComponent(dealNo || "");

        this.getPrototol(dealNo, this.token);
    },

    methods: {
        getPrototol: function(id, token) {
            let self = this;
            this.$request({
                method: "post",
                url: `/h5/deal/loanDetail.json`,
                data: this.$qs.stringify({
                    dealNo: id,
                    token: token
                })
            })
                .then(res => {
                    const { code, msg, data } = res;
                    self.jxborderDetails = data;
                })
                .catch(err => {
                    this.$toast(err);
                });
        },
        cancelOrder: function() {
            let _self = this;
            let mask = this.$confirm({
                title: "温馨提示",
                closeAble: false,
                content: "<p style='text-align: center;'>您确定取消订单吗？</p>",
                ok() {
                    mask.close();
                    _self
                        .$request({
                            method: "post",
                            url: `/h5/deal/destroy.json`,
                            data: _self.$qs.stringify({
                                dealNo: _self.dealNo,
                                token: _self.token
                            })
                        })
                        .then(res => {
                            mask.close();
                            callHandler("xhCancelOrderSuc");
                        })
                        .catch(err => {
                            mask.close();
                            _self.$toast(err);
                        });
                }
            }).show();
        },
        payment: function() {
            callHandler("xhPayOrder", {
                categoryId: this.jxborderDetails.category,
                subCategoryId: this.jxborderDetails.subCategory,
                amount: this.jxborderDetails.amount,
                dealNo: this.jxborderDetails.dealNo,
                productId: this.jxborderDetails.productId,
                productName: this.jxborderDetails.productName,
                variableAnnualRate: this.jxborderDetails.variableAnnualRate,
                annualRate: this.jxborderDetails.annualRate
            });
        },
        goInfo() {
            sensors.track("TMClickWangDaiInformationDisclosure");
            bridgeRedirect(`${location.origin}${location.pathname}#/informationDisclosure?token=${this.token}&loanCode=${this.jxborderDetails.loanCode}`);
        },
        format(num) {
            return formatNumber(num);
        },
        goRefund(event) {
            sensors.track("TMWangDaiProductRepayPage");

            redirectApp("ghToProductReturnDetail", {
                dealNo: this.jxborderDetails.dealNo,
                type: "2",
                login: "1"
            });
        },
        downFile() {
            sensors.track("TMOrderAgreement");
            this.$toast("服务协议请到PC官网查看");
        }
    }
};
</script>
<style lang="less">
@import "../css/orderDetails.less";
</style>
